exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-templates-completed-js": () => import("./../../../src/templates/completed.js" /* webpackChunkName: "component---src-templates-completed-js" */),
  "component---src-templates-front-js": () => import("./../../../src/templates/front.js" /* webpackChunkName: "component---src-templates-front-js" */),
  "component---src-templates-question-js": () => import("./../../../src/templates/question.js" /* webpackChunkName: "component---src-templates-question-js" */)
}

